



























































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import ProductState from '@/components/Products/ProductState.vue';
import DepositFixedTermMaturitySettings from '@/models/Products/ProductSettings/DefaultSettings/FixedTermMaturity/DepositFixedTermMaturitySettings';
import DepositFixedTermMaturitySettingsEditDialog from '@/components/Products/ProductSettings/DefaultSettings/FixedTermMaturity/DepositFixedTermMaturitySettingsEditDialog.vue';
import FixedTermMaturityType from "@/models/Products/ProductSettings/DefaultSettings/FixedTermMaturity/FixedTermMaturityType";
import EntityType from '@/models/Shared/EntityType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'DepositFixedTermMaturitySettingsRead', components: { ProductState, DepositFixedTermMaturitySettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    FixedTermMaturityType = FixedTermMaturityType;
    EntityType = EntityType;
    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: DepositFixedTermMaturitySettings;

    @Prop({required: true})
    entityType: EntityType;

    get settingsAvailable() {
        return (this.settings !== undefined);
    }
}
